import React, { useRef, useState } from 'react';
import { Share2, Download, Loader2 } from 'lucide-react';
import { captureNode, shareCanvas, saveCanvas } from '../../lib/shareImage';
import MySelectionShareCard from './MySelectionShareCard';
import { getInviteLines, trackShare } from '../../lib/referralShare';

const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=it.rvincente.app.twa';
const APPLE_STORE_URL = 'https://apps.apple.com/app/rvincente-pronostici-calcio/id6760314785';

const shareText = (inviteLines) => [
  'Ehy guarda la mia selezione su RVINCENTE! La seguo live evento per evento.',
  inviteLines,
  `\nScarica l'app:\n\nGoogle Play: ${GOOGLE_PLAY_URL}\n\nApple Store: ${APPLE_STORE_URL}`,
].filter(Boolean).join('\n');

// "Condividi" + "Salva immagine" under the selection list.
export const MySelectionShare = ({ picks }) => {
  const cardRef = useRef(null);
  const [busy, setBusy] = useState(null);

  const run = async (kind) => {
    setBusy(kind);
    try {
      const canvas = await captureNode(cardRef.current, { scale: picks.length > 8 ? 1.5 : 2 });
      if (!canvas) return;
      if (kind === 'save') return await saveCanvas(canvas, 'selezione-rvincente');
      trackShare('selezione');
      await shareCanvas(canvas, shareText(await getInviteLines()), 'selezione-rvincente');
    } finally { setBusy(null); }
  };

  return (
    <>
      <div style={{ position: 'fixed', left: -10000, top: 0, pointerEvents: 'none' }} aria-hidden="true">
        <MySelectionShareCard ref={cardRef} picks={picks} />
      </div>
      <div className="mt-3 grid grid-cols-2 gap-2">
        <button onClick={() => run('share')} disabled={!!busy} className="h-10 rounded-xl bg-[#F5A623] text-[#1A1A1A] text-xs font-black flex items-center justify-center gap-1.5 active:scale-95 transition-transform disabled:opacity-60" data-testid="my-selection-share-btn">
          {busy === 'share' ? <Loader2 className="w-4 h-4 animate-spin" /> : <Share2 className="w-4 h-4" />} Condividi
        </button>
        <button onClick={() => run('save')} disabled={!!busy} className="h-10 rounded-xl bg-[#1E1E1E] border border-white/10 text-white text-xs font-bold flex items-center justify-center gap-1.5 active:scale-95 transition-transform disabled:opacity-60" data-testid="my-selection-save-btn">
          {busy === 'save' ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />} Salva immagine
        </button>
      </div>
    </>
  );
};

export default MySelectionShare;
